export default function AlertsListController($scope, $rootScope, $filter, configurationsService, gettextCatalog) {

  'ngInject';

  $scope.configurations = [];
  $scope.filteredConfigurations = [];
  var currentUser = $rootScope.currentUser;
  $scope.searchText = '';
  $scope.errorFlag = false;
  $scope.errorText = "";
  $scope.loading = true;
  $scope.onLoadErrorText = '';
  $scope.onLoadErrorFlag = false;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;
  var orderBy = $filter('orderBy');

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 15;
  $scope.maxSize = 1;

  $scope.orderConfigurations = function (predicate) {

    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = true;
    }
    $scope.predicate = predicate;
  };

  $scope.applyFilter = function () {
    $scope.filteredConfigurations = $filter('filter')($scope.configurations, $scope.searchText);
  };

  //reset flags after user selects a new row
  $scope.resetFlags = function () {
    $scope.errorFlag = false;
    $scope.errorText = "";
  };

  //Tracks the selected row.
  $scope.setSelectedRow = function (configData) {
    $scope.selectedRow = configData.name;
    $scope.resetFlags();
  };

  function getConfigurations() {
    configurationsService.getAllConfigurations()
      .then(function (response) {
        $scope.loading = true;
        $scope.configurations = response.data;
        $scope.applyFilter();
      })
      .catch(function (error) {
        var errorMsg = gettextCatalog.getString("An error occurred while retrieving configurations");
        $scope.onLoadErrorText = errorMsg;
        $scope.onLoadErrorFlag = true;
      })
      .finally(function () {
        $scope.loading = false;
      });
  }

  if (currentUser != null) {
    getConfigurations();
  }
  $scope.$watch(function () {
    return $rootScope.currentUser;
  }, function (newVal, oldVal) { //if currentUser (with visible datapoints) isn't defined on page load, wait to populate the datapoint list until it is
    if (typeof oldVal === 'undefined') {
      if (!(typeof newVal === 'undefined')) {
        currentUser = $rootScope.currentUser;
        getConfigurations();
      }
    }
  });
}